module.exports = __webpack_public_path__ + "assets/3b2fe8fbfc6fd06480be020717b9ba9a.mp3";